export default __webpack_public_path__ + "static/media/project-series.5ca1128e.svg";